import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: { padding: '0 .5rem' },
    hover: {
        '&:hover': {
            color: theme?.app?.applicationColors.fontColor || '#202020',
            backgroundColor: theme?.app?.clientTheme.colors.primaryColorLight || '#0A2240'
        }
    },
    selected: {
        color: theme?.app?.applicationColors.enumColors.white || '#fff',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073'
    },
    walletOptionSelectWrapper: {
        display: 'flex',
        flexGrow: 1,
        '&:hover': {
            backgroundColor: '#E0EBFD',
            color: '#000'
        },
        '& > div': { borderTop: '1px solid #E4E4E4' },
        '&:first-child > div': { borderTop: 'none' }
    },
    walletOptionSelect: {
        display: 'flex',
        flexFlow: 'row',
        flexGrow: 1,
        alignItems: 'center',
        padding: '10px',
        margin: '0 10px',
        cursor: 'default',
        '&__left': { flexGrow: 1 },
        '&__right': {
            paddingLeft: '1rem',
            paddingRight: '1rem',
            borderLeft: '1px solid #E4E4E4'
        }
    }
}));